import { Divider, styled } from "@mui/material";

export const StyledDivider = styled(Divider)({
  marginTop: "10px",
  marginBottom: "10px",
});
